import { defineStore } from "pinia";
import EvacuationService, {
  type EvacuationStatus,
  type CreateEvacuationRequest,
  type EvacuationNotification
} from "src/services/evacuationService";

export const useEvacuationStore = defineStore({
  persist: false,
  id: "evacuation",
  state: () => ({
    statuses: {} as Record<number, EvacuationStatus>,
    loading: false
  }),
  getters: {
    getStatus: (state) => (caseID: number): EvacuationStatus => {
      return state.statuses[caseID] || { sent: false };
    },
    isSent: (state) => (caseID: number): boolean => {
      return state.statuses[caseID]?.sent === true;
    }
  },
  actions: {
    async fetchStatus(caseID: number, linkedCaseIDs: number[] = []): Promise<void> {
      const service = new EvacuationService();
      try {
        const status = await service.getStatus(caseID, linkedCaseIDs);
        this.statuses[caseID] = status;
      } catch (err) {
        console.error("Failed to fetch evacuation status:", err);
        this.statuses[caseID] = { sent: false };
      }
    },

    async sendNotification(caseID: number, payload: CreateEvacuationRequest): Promise<EvacuationNotification> {
      this.loading = true;
      const service = new EvacuationService();
      try {
        const notification = await service.sendNotification(caseID, payload);
        this.statuses[caseID] = {
          sent: true,
          sentAt: notification.createdAt,
          caseID: notification.caseID,
          medicName: notification.medicName,
          createdBy: notification.createdBy,
        };
        return notification;
      } finally {
        this.loading = false;
      }
    },

    markSent(caseID: number): void {
      this.statuses[caseID] = { sent: true };
    },

    clearStatuses(): void {
      this.statuses = {};
    }
  }
});
